<template>
  <component :is="tag" v-bind="boundProps" @click="$emit('click', $event)">
    <slot>{{ label }}</slot>
  </component>
</template>

<script>
/** @typedef {'button', 'submit', 'a'} ButtonType */
export const ButtonType = Object.freeze({
  BUTTON: 'button',
  SUBMIT: 'submit',
  LINK: 'a',
});

export default {
  name: 'BaseBtn',
  props: {
    type: {
      type: String,
      default: ButtonType.LINK,
      validator(v) {
        return Object.values(ButtonType).includes(v);
      },
    },
    label: { type: String, default: null },
    href: { type: String, default: null },
    block: { type: Boolean, default: false },
    default: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
    secondary: { type: Boolean, default: false },
    tertiary: { type: Boolean, default: false },
    lightGray: { type: Boolean, default: false },
    border: { type: Boolean, default: false },
    transparent: { type: Boolean, default: false },
    link: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    attributes: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    typeAttr() {
      if ([ButtonType.BUTTON, ButtonType.SUBMIT].includes(this.type)) {
        return this.type;
      }

      // Default to type="button" when href is empty
      if (!this.href) {
        return ButtonType.BUTTON;
      }

      return null;
    },
    tag() {
      return this.href ? ButtonType.LINK : ButtonType.BUTTON;
    },
    classList() {
      const blockSelector = 'base-btn';

      return [
        blockSelector,
        {
          [`${blockSelector}--block`]: this.block,
          [`${blockSelector}--default`]:
            this.default ||
            (!this.primary &&
              !this.secondary &&
              !this.transparent &&
              !this.tertiary &&
              !this.lightGray &&
              !this.link),
          [`${blockSelector}--primary`]: this.primary,
          [`${blockSelector}--secondary`]: this.secondary,
          [`${blockSelector}--tertiary`]: this.tertiary,
          [`${blockSelector}--light-gray`]: this.lightGray,
          [`${blockSelector}--transparent`]: this.transparent,
          [`${blockSelector}--border`]: this.border,
          [`${blockSelector}--link`]: this.link,
          [`${blockSelector}--icon`]: this.icon,
        },
      ];
    },
    boundProps() {
      return {
        type: this.typeAttr,
        class: this.classList,
        href: this.disabled ? null : this.href,
        disabled: this.disabled,
        ...this.attributes,
      };
    },
  },
};
</script>
